import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { InputCost } from './inputmodels/inputcost.model';
import { InputOrder } from './inputmodels/inputorder.models';
import { InputValue } from './inputmodels/inputvalue.model';
import { InputContractService } from './inputservices/inputcontract.service';
import { InputCostService } from './inputservices/inputcost.service';
import { InputOrderService } from './inputservices/inputorder.service';
import { InputValueService } from './inputservices/inputvalue.service';
import { InputContract } from './inputmodels/inputcontract.model';
import { InputItem } from '../inputcommon/inputcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';
import { KindBoard } from 'src/utils/enums';

@Component({
    selector: 'cp-inputcharts',
    templateUrl: './inputcharts.component.html',
    styleUrls: ['./inputcharts.component.css'],
    standalone: false
})
export class InputChartsComponent extends PageBase implements OnInit, OnChanges{

  @Input() inputInfo: InputItem;
  inputValue: InputValue = new InputValue();
  inputValueContract: InputContract = new InputContract();
  inputCost: InputCost = new InputCost();
  inputQuantityOrder: InputOrder = new InputOrder();
  isHideLoadingCost: boolean;
  isHideLoadingOrder: boolean;
  isHideLoadingContract: boolean;
  isHideLoadingValueQuantity: boolean;

  constructor(public objInjector: Injector,
              private inputValueService: InputValueService,
              private inputContractService: InputContractService,
              private inputCostService: InputCostService,
              private inputOrderService: InputOrderService,
              public contextApplication: ContextApplication)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadCharts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.inputInfo.currentValue['inputId']) {
      this.loadCharts();
      this.GetInputsForCharts();
    }
  }

  private async GetInputsForCharts() {
    try {
      if (this.contextApplication.currentVision == KindBoard.Insumo.valueOf()) {
        this.inputValue = await this.inputValueService.GetInfoInput(this.inputInfo);
        this.inputValueContract = await this.inputContractService.GetInfoInput(this.inputInfo);
        this.inputCost = await this.inputCostService.GetInfoInput(this.inputInfo);
        this.inputQuantityOrder = await this.inputOrderService.GetInfoInput(this.inputInfo);
      }
      else {
        this.inputValue = await this.inputValueService.GetInfoInputByTask(this.inputInfo);
        this.inputValueContract = await this.inputContractService.GetInfoInputByTask(this.inputInfo);
        this.inputCost = await this.inputCostService.GetInfoInputByTask(this.inputInfo);
        this.inputQuantityOrder = await this.inputOrderService.GetInfoInputByTask(this.inputInfo);
      }
      this.hideloadCharts();
    }
    catch {
      this.hideloadCharts();
    }
  }

  private loadCharts() {
    this.isHideLoadingCost = false;
    this.isHideLoadingOrder = false;
    this.isHideLoadingContract = false;
    this.isHideLoadingValueQuantity = false;
  }

  private hideloadCharts() {
    this.isHideLoadingCost = true;
    this.isHideLoadingOrder = true;
    this.isHideLoadingContract = true;
    this.isHideLoadingValueQuantity = true;
  }

  onReceiveLiterals(): void {}
}
